import React from "react";
import { ReactComponent as YourSvg } from "../../assets/logos/amazon.svg";

const AmazonIcon = () => {
  return <YourSvg />;
};

export default AmazonIcon;
